// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.management-card {
	width: 100%;
	max-width: 500px;
	height: 250px;
	text-align: center;
	transition: transform 0.2s, box-shadow 0.2s;
	margin: 30px 0;
}

.management-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.management-card-title {
	font-size: 26px;
	font-weight: 600;
	color: var(--white);
	margin-bottom: 30px;
}

@media (max-width: 480px) {
	.management-card {
		padding: 15px;
	}

	.management-card-title {
		font-size: 24px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/ManagementCard/ManagementCard.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,2BAA2B;CAC3B,yCAAyC;AAC1C;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".management-card {\n\twidth: 100%;\n\tmax-width: 500px;\n\theight: 250px;\n\ttext-align: center;\n\ttransition: transform 0.2s, box-shadow 0.2s;\n\tmargin: 30px 0;\n}\n\n.management-card:hover {\n\ttransform: translateY(-5px);\n\tbox-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n}\n\n.management-card-title {\n\tfont-size: 26px;\n\tfont-weight: 600;\n\tcolor: var(--white);\n\tmargin-bottom: 30px;\n}\n\n@media (max-width: 480px) {\n\t.management-card {\n\t\tpadding: 15px;\n\t}\n\n\t.management-card-title {\n\t\tfont-size: 24px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
